import { render } from "./upsert.vue?vue&type=template&id=2f86193f"
import script from "./upsert.vue?vue&type=script&lang=js"
export * from "./upsert.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__